<h4 class="title" translate>HOME_PAGE.PAY_WITH </h4>
<div class="shop">
  <h4 translate>HOME_PAGE.SHOP</h4>
  <a routerLink="/partner/shops" translate>HOME_PAGE.SEE_ALL</a>
</div>
<div class="card">
  <div class="desktop-grid">

    <p-carousel [value]="merchantList" [numVisible]="4" [showNavigators]="true" [numScroll]="4"
      [responsiveOptions]="responsiveOptions">

      <ng-template let-item pTemplate="merchantList">
        <taly-shop-card [shop]="item" />
      </ng-template>
      <ng-template pTemplate="footer">
        <button routerLink="/shops" class="btn btn-outline" translate> HOME_PAGE.EXPLORE </button>
      </ng-template>
    </p-carousel>
  </div>

  <div class="responsive-grid">
    <taly-mobile-taly-partners [partenrs]="merchantList" />
  </div>
</div>